import {bindable, customElement, inject} from "aurelia-framework";
import {Client} from "../api/client";

@inject(Client)
@customElement('filter-conditions-prediction')
export class FilterConditionInput {

    @bindable object;
    @bindable field;

    prediction = [];
    error = false;

    constructor(client) {
        this.client = client;
    }

    bind() {
        this.update();
    }

    fieldChanged() {
        this.update();
    }

    objectChanged() {
        this.update();
    }

    update() {

        this.error = false;
        this.loading = true;

        this.client.get('filter/prediction/' + this.object.modelId + '/' + this.object.id + '/' + this.field).then(data => {
            this.prediction = data;
            this.loading = false;
        }).catch(error => {
            this.error = true;
            this.loading = false;
        });
    }
}
